/**
 * <s-promo-popup data-dialog-id data-delay data-storage-key [data-once]>
 * Opens the promo <dialog> after `data-delay` ms. With `data-once`, a closed
 * popup stays closed for the rest of the browser session; the reminder pill
 * ([data-promo-reminder]) is shown instead so visitors can reopen it.
 * In the theme editor it never auto-opens; selecting the block opens it.
 */
class SPromoPopup extends HTMLElement {
  #ac;
  #timer;

  connectedCallback() {
    const dialog = document.getElementById(this.dataset.dialogId);
    if (!dialog) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const reminder = this.querySelector('[data-promo-reminder]');
    const key = this.dataset.storageKey;
    const once = this.hasAttribute('data-once');

    const seen = () => {
      try { return sessionStorage.getItem(key) === '1'; } catch { return false; }
    };
    const remember = () => {
      try { sessionStorage.setItem(key, '1'); } catch { /* storage blocked */ }
    };
    const open = () => {
      if (!dialog.open) dialog.showModal();
    };

    dialog.addEventListener('close', () => {
      remember();
      if (reminder) reminder.hidden = false;
    }, opts);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        if (this.contains(e.target) || e.target === this) open();
      }, opts);
      document.addEventListener('shopify:block:deselect', (e) => {
        if ((this.contains(e.target) || e.target === this) && dialog.open) dialog.close();
      }, opts);
      return;
    }

    if (once && seen()) {
      if (reminder) reminder.hidden = false;
      return;
    }

    const delay = Number(this.dataset.delay) || 0;
    this.#timer = setTimeout(open, delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#ac?.abort();
  }
}

if (!customElements.get('s-promo-popup')) customElements.define('s-promo-popup', SPromoPopup);
